import React from 'react';
import { StyledHeading } from '../../components/Dashboard/styles.js';
import { Table } from 'antd';
import { withTranslation } from 'react-i18next';
import { TOP_TEN_TEMPLATES_TABLE as trans } from './TranslationValues.js';

const NAMESPACE = ['TOP_TEN_TEMPLATES_TABLE']

const TopTenTemplates = props => {
  const { title, data, t } = props;
  const columns = [
    {
      title: `${t(trans.TEMPLATE_NAME_COLUMN_TITLE.key,trans.TEMPLATE_NAME_COLUMN_TITLE.value)}`,
      dataIndex: 'templateName',
      align: 'center',
      key: "templateName"
    },
    {
      title: `${t(trans.FAILURES_COUNT_COLUMN_TITLE.key,trans.FAILURES_COUNT_COLUMN_TITLE.value)}`,
      dataIndex: 'noOfFailures',
      align: 'center',
      key: "noOfFailures"
      
    },
  ];

  return (
    <>
      <StyledHeading>
        <h2>{title}</h2>
      </StyledHeading>
      <Table className="top10-templates-table" dataSource={data} columns={columns} pagination={false} 
      locale={{ emptyText: t(trans.NO_DATA_TEXT.key, trans.NO_DATA_TEXT.value)}} />
    </>
  );
};

export default withTranslation(NAMESPACE)(TopTenTemplates);
